<div
  class="images-group"
  [ngStyle]="
    isGroup
      ? {
          width: width + 'px',
          height: height + 'px',
        }
      : undefined
  "
>
  <app-photo
    *ngFor="let image of images; let i = index; trackBy: trackByFn"
    class="images-group__item"
    [ngClass]="'images-group__item_column-' + (!isGroup ? 1 : [2, 3].includes(images.length) ? 2 : 3)"
    [class.images-group__item_bg]="!!image.src"
    [type]="'photo'"
    [photoSrc]="image.src"
    [width]="isGroup ? '100%' : image.width + 'px'"
    [height]="isGroup ? '100%' : image.height + 'px'"
    [showPreview]="false"
    [loading]="image.loading"
    (click)="onClickPhoto(i)"
  ></app-photo>
</div>

<ng-template #previewTmp let-preview>
  <preview [index]="previewImageIndex" [images]="images" (close)="preview.complete()"></preview>
</ng-template>
